/* eslint-disable import/prefer-default-export */
export const FORM_NAME_ENUMS = {
  MERGE_REQUEST_FORM: 'MERGE_REQUEST_FORM',
  PROJECT_ISSUE_FORM: 'PROJECT_ISSUE_FORM',
  ISSUE_DISCUSSION_FORM: 'ISSUE_DISCUSSION_FORM',
  PROJECT_BASE_SETTING_FORM: 'PROJECT_BASE_SETTING_FORM',
  APPROVAL_RULE_FORM: 'APPROVAL_RULE_FORM',
  PIPELINE_SCHEDULE_FORM: 'PIPELINE_SCHEDULE_FORM',
  PROJECT_CREATE_FORM: 'PROJECT_CREATE_FORM',
  MIRROR_CREATE_FORM: 'MIRROR_CREATE_FORM',
  IMPORT_BASE_FORM: 'IMPORT_BASE_FORM',
  PROJECT_IMPORT_FORM: 'PROJECT_IMPORT_FORM',
  FORK_CREATE_FORM: 'FORK_CREATE_FORM',
  TEAM_CREATE_FORM: 'TEAM_CREATE_FORM',
  COMPANY_CREATE_FORM: 'COMPANY_CREATE_FORM',
  COMMIT_CREATE_FORM: 'COMMIT_CREATE_FORM',
  UPLOAD_FILES_FORM: 'UPLOAD_FILES_FORM',
  DELETE_FILE_FORM: 'DELETE_FILE_FORM',
  DELETE_DIRECTORY_FORM: 'DELETE_DIRECTORY_FORM',
  TEAM_APPROVAL_RULE_FORM: 'TEAM_APPROVAL_RULE_FORM',
  COMPANY_APPROVAL_RULE_FORM: 'COMPANY_APPROVAL_RULE_FORM',
  CUSTOM_ROLE_CREATE: 'CUSTOM_ROLE_CREATE',
  CUSTOM_ROLE_EDIT: 'CUSTOM_ROLE_EDIT',
  CHERRY_PICK_FORM: 'CHERRY_PICK_FORM',
  COMMIT_REVERT_FORM: 'COMMIT_REVERT_FORM',
  COMMIT_CONFLICTS_FORM: 'COMMIT_CONFLICTS_FORM',
  PROJECT_SETTINGS_EDIT_CI_CD_FORM: 'PROJECT_SETTINGS_EDIT_CI_CD_FORM',
  COMMIT_PIPELINE_TEMPLATE_FORM: 'COMMIT_PIPELINE_TEMPLATE_FORM',
  ADMIN_SETTINGS_OIDC_CREATE_FORM: 'ADMIN_SETTINGS_OIDC_CREATE_FORM',
  ADMIN_SETTINGS_LDAP_CREATE_FORM: 'ADMIN_SETTINGS_LDAP_CREATE_FORM',
  ADMIN_SETTINGS_SAML_CREATE_FORM: 'ADMIN_SETTINGS_SAML_CREATE_FORM',
  ADMIN_SETTINGS_OIDC_EDIT_FORM: 'ADMIN_SETTINGS_OIDC_EDIT_FORM',
  ADMIN_SETTINGS_LDAP_EDIT_FORM: 'ADMIN_SETTINGS_LDAP_EDIT_FORM',
  ADMIN_SETTINGS_SAML_EDIT_FORM: 'ADMIN_SETTINGS_SAML_EDIT_FORM',
  PROJECT_SETTING_WEBHOOK_FORM_URL: 'PROJECT_SETTING_WEBHOOK_FORM_URL',
  ADMIN_LOGS_AUDIT_SETTINGS_FORM: 'ADMIN_LOGS_AUDIT_SETTINGS_FORM',
  LEAVE_PROJECT: 'LEAVE_PROJECT',
  REPORT_PROJECT: 'REPORT_PROJECT',
  CREATE_CUSTOM_SCRIPT_FORM: 'CREATE_CUSTOM_SCRIPT_FORM',
  UPDATE_CUSTOM_SCRIPT_FORM: 'UPDATE_CUSTOM_SCRIPT_FORM',
  CREATE_CUSTOM_VARIABLE_FORM: 'CREATE_CUSTOM_VARIABLE_FORM',
  UPDATE_CUSTOM_VARIABLE_FORM: 'UPDATE_CUSTOM_VARIABLE_FORM',
  DELETE_CUSTOM_VARIABLE_FORM: 'DELETE_CUSTOM_VARIABLE_FORM',
  CI_CD_VARIABLES_PIPELINE_START: 'CI_CD_VARIABLES_PIPELINE_START',
  REPORT_COMPANY: 'REPORT_COMPANY',
  LEAVE_COMPANY: 'LEAVE_COMPANY',
  REPORT_TEAM: 'REPORT_TEAM',
  LEAVE_TEAM: 'LEAVE_TEAM',
  COMPANY_SETTING_CI_CD_FORM: 'COMPANY_SETTING_CI_CD_FORM',
  TEAM_SETTING_CI_CD_FORM: 'COMPANY_SETTING_CI_CD_FORM',
  ADMIN_CI_CD_FORM: 'ADMIN_CI_CD_FORM',
  ENVIRONMENT_CREATE: 'ENVIRONMENT_CREATE',
  ENVIRONMENT_EDIT: 'ENVIRONMENT_EDIT',
  MASS_IMPORT_FORM: 'MASS_IMPORT_FORM',
  AGENT_DELETE: 'AGENT_DELETE',
  AGENT_CONNECT: 'AGENT_CONNECT',
  TOKEN_DELETE: 'TOKEN_DELETE',
  TOKEN_CREATE_FORM: 'TOKEN_CREATE_FORM'
  // PIPELINE_SCHEDULE_EDIT_FORM: 'PIPELINE_SCHEDULE_EDIT_FORM'
  // CREATE_MERGE_REQUEST_FORM: 'CREATE_MERGE_REQUEST_FORM',
};
